// extracted by mini-css-extract-plugin
module.exports = {"root":"accordion-help-text_root__eUC8M","sizelg":"accordion-help-text_sizelg__mMmPi","sizexl":"accordion-help-text_sizexl__9rNtt"};